// extracted by mini-css-extract-plugin
export default {"container":"addPenaltyBonus_container__wegW1","button":"addPenaltyBonus_button__YB4Gv","content":"addPenaltyBonus_content__8C3lz","sign":"addPenaltyBonus_sign__MZsnW"};